import { TsDOM as q} from '@/scripts/core/TsDOM'
import { CookieBanner } from '@/scripts/theme/cookie-banner';

q.safeDefineElement(CookieBanner)